import { getAllFamily } from "@/service";
import moment from "moment";
import { Validator } from "vee-validate";

export const padLeft = (len, str) => (val) => val.toString().padLeft(len, str);
export const DIFF_BETWEEN_ROC_AND_YEARS = 1911;
export const YEARS_RANGE = 60;

//自訂欄位檢核
Validator.extend("duplicate", {
  getMessage: (field) => {
    return `您輸入的${field}已重複`;
  },
  validate: (value, pool) => {
    return !pool.find((i) => i === value);
  }
});
Validator.extend("checkEngNumDash", {
  getMessage: "不可輸入英文、數字與-以外內容",
  validate: (value) => {
    let isNonEmpty = value.trim().length > 0;
    let isFormatCurrect = /^[a-zA-Z0-9\\-]*$/.test(value);
    return isNonEmpty && isFormatCurrect;
  }
});
Validator.extend("checkCarType", {
  getMessage: "不可輸入中英文、數字與-以外內容",
  validate: (value) => {
    let isNonEmpty = value.trim().length > 0;
    let isFormatCurrect = /^[\u4e00-\u9fa5a-zA-Z0-9\-\(\)]*$/.test(value);
    return isNonEmpty && isFormatCurrect;
  }
});
Validator.extend("checkRemark", { 
  getMessage: "不可輸入中英文、數字、-以外內容",
  validate: (value) => {
    let isNonEmpty = value.trim().length > 0;
    let isFormatCorrect = /^[\u4e00-\u9fa5a-zA-Z0-9\-:\(\)\n]*$/.test(value);
    return isNonEmpty && isFormatCorrect;
  }
});
Validator.extend("checkCarTypeLength", {
  getMessage: "長度不可超過40字元",
  validate: (value) => {
    let isNonEmpty = value.trim().length > 0;
    let length = value.length;
    let byte;
    let byteLen = 0;
    for (var i = 0; i < length; i++) {
      byte = value.charCodeAt(i);
      while (byte > 0) {
        byteLen++;
        byte = byte >> 8;
      }
    }
    return isNonEmpty && byteLen <= 40;
  }
});

export default {
  components: {
    RocDatePicker: () => import("./components/rocDatePicker")
  },
  data: () => ({
    options: {
      families: []
    },
    convert: {
      familyOrder: {
        0: 0,
        1: 1,
        2: 2,
        3: 3,
        4: 5,
        5: 4
      }
    },
    editData: {
      // rdstdt 投保日期
      year: moment().getROCDate("YYYY"),
      month: padLeft(2, "0")(moment().month() + 1),
      day: padLeft(2, "0")(moment().date())
    }
  }),
  methods: {
    getOptions() {
      this.getFamilyOption();
    },
    async getFamilyOption() {
      const user = JSON.parse(localStorage.userItems);
      const res = await getAllFamily(user.agidno, user.csidno);

      this.options.families = window._.orderBy(
        res.data,
        (x) => this.convert.familyOrder[x.familyrl]
      );
    },
    cancelAdd(action = "新增") {
      this.$toast.info({ title: `取消${action}` });
      this.toPolicyInfo();
    },
    toPolicyInfo() {
      this.$router.push({
        name: "policyInfo-edit-list"
      });
    },
    toPolicyEditList(query) {
      this.$router.push({
        name: "policyInfo-edit-list",
        query
      });
    },
    toMenu(route) {
      this.$router.push({
        name: route?route.name:"add-new-contract"
      });
    }
  },
  computed: {
    rdstdtDate() {
      return [
        +this.editData.year + DIFF_BETWEEN_ROC_AND_YEARS,
        this.editData.month,
        this.editData.day
      ].join("-");
    },
    rdstdt() {
      return this.rdstdtDate + " 00:00:00";
    },
    isRdstdtError() {
      return !moment(this.rdstdt).isSameOrBefore(moment(), "day");
    },
    user_id() {
      return this.$store.state.userInfo.id;
    }
  },
  mounted() {
    this.getOptions();
  }
};

// https://vee-validate.logaretm.com/v2/api/errorbag.html#api
